export interface AppNavigationShortcut {
  id: string;
  label: string;
  route: string;
  icon: string;
  group: string;
  permission?: string[];
}

export const APP_PRIMARY_COMMANDS: AppNavigationShortcut[] = [
  { id: 'launchpad', label: 'Launchpad', route: '/launchpad', icon: 'home', group: 'Home' },
  { id: 'supply-planning', label: 'Supply Planning', route: '/supply-planning', icon: 'inventory_2', group: 'Planning' },
  {
    id: 'submission-status',
    label: 'Supply Planning Submission Status',
    route: '/supply-planning/submission-status',
    icon: 'fact_check',
    group: 'Planning',
  },
  { id: 'forecasting', label: 'Forecasting', route: '/forecasting/copilot', icon: 'insights', group: 'Forecasting' },
  { id: 'reports', label: 'Reports', route: '/report/product-report', icon: 'description', group: 'Reporting' },
];

export const APP_QUICK_NAV_ROUTES = [
  '/launchpad',
  '/dashboard/rdf-dashboard',
  '/forecasting/copilot',
  '/supply-planning',
  '/report/product-report',
];
